// extracted by mini-css-extract-plugin
module.exports = {"header":"DesktopInternalStickyHeader__header__ioYwQ"};